module.exports = __webpack_public_path__ + "static/media/0160_Small.bd8637a5.jpg";